
export class ConfigurationGabaritSpecifiquePage {
    public readonly estAfficherTiroirPrimeurs: boolean;
    public readonly estAfficherMenuDroite: boolean;
    public readonly estMenuDroiteEpuree: boolean;
    public readonly identifiantMenuDroiteActif: string | undefined;
    public readonly identifiantAideContact: string | undefined;
    public readonly estAfficherAstuces: boolean;
    public readonly estAfficherDemandeEnCours: boolean;

    constructor(estAfficherTiroirPrimeurs: boolean, 
            estAfficherMenuDroite: boolean, 
            estMenuDroiteEpuree: boolean, 
            identifiantMenuDroiteActif: string | undefined, 
            identifiantAideContact: string | undefined, 
            estAfficherAstuces: boolean,
            estAfficherDemandeEnCours: boolean) {
        this.estAfficherTiroirPrimeurs = estAfficherTiroirPrimeurs;
        this.estAfficherMenuDroite = estAfficherMenuDroite;
        this.estMenuDroiteEpuree = estMenuDroiteEpuree;
        this.identifiantMenuDroiteActif = identifiantMenuDroiteActif;
        this.identifiantAideContact = identifiantAideContact;
        this.estAfficherAstuces = estAfficherAstuces;
        this.estAfficherDemandeEnCours = estAfficherDemandeEnCours;
    }

    public obtenirConfigurationsTiroirPrimeurs() {
        return {
            consultation: {
                afficherTiroirPrimeurs: this.estAfficherTiroirPrimeurs
            }
        };
    }

    public obtenirConfigurationsAfficherMenuDroite() {
        return {
            consultation: {
                afficherMenuDroite: this.estAfficherMenuDroite,
            }
        };
    }

    public obtenirConfigurationsAvecMenuDroiteEpuree() {
        return {
            consultation: {
                afficherSondageCaisse: !this.estMenuDroiteEpuree,
                afficherLogoAssuranceDepot: !this.estMenuDroiteEpuree,
                afficherLiensUtiles: !this.estMenuDroiteEpuree,
            }
        };
    }

    public obtenirConfigurationsAvecIdentifiantMenuDroite() {
        return {
            consultation: {
                menuPrincipal: {
                    identifiantMenu: this.identifiantMenuDroiteActif,
                }
            }
        };
    }

    public obtenirConfigurationsAideContact() {
        return {
            consultation: {
                aideContactV2: {
                    identifiantMenu: this.identifiantAideContact
                }
            }
        };
    }
    
    public obtenirConfigurationAstuces() {
        return {
            consultation: {
                afficherAstuces: this.estAfficherAstuces
            }
        };
    }
    
    public obtenirConfigurationDemandeEnCours() {
        return {
            consultation: {
                afficherDemandeEnCours: this.estAfficherDemandeEnCours
            }
        };
    }
}
